'use client'

import { LightCard } from '@/frontend/design-system/data-display/Card'
import { Preview } from '@/frontend/design-system/forms/MarkdownEditor'
import { H2 } from '@/frontend/design-system/typography/Heading'

type HowIWorkProps = {
  markdown: string
}

export function HowIWork({ markdown }: HowIWorkProps) {
  return (
    <div className='flex flex-col items-center justify-center space-y-6'>
      <H2>Współpraca ze mną</H2>
      <LightCard className='max-w-5xl'>
        <Preview content={{ markdown }} />
      </LightCard>
    </div>
  )
}
